import * as node from '../node/buffer';
export function isBuffer(value) {
  return value && typeof value === 'object' && value.isBuffer;
}
export function toBuffer(data) {
  return node.toBuffer ? node.toBuffer(data) : data;
}
export function bufferToArrayBuffer(buffer) {
  if (isBuffer(buffer)) {
    const typedArray = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.length);
    return typedArray.slice().buffer;
  }

  return buffer;
}
//# sourceMappingURL=buffer-utils.js.map